import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';

const momentConstructor = moment;

@Pipe({name: 'amLocal'})
export class LocalTimePipe implements PipeTransform {
  public transform(value: Date | moment.Moment | string | number) {
    if (!value) {
      return '';
    }

    return momentConstructor(value).local();
  }
}
